import { Await } from "react-router";
import CustomError from "@components/Error/CustomError";
import BTSG60PageContent from "@pages/Keyword/customPages/BTSG60Page/BTSG60PageContent";
import { BTSG60Context } from "@pages/Keyword/customPages/BTSG60Page/utils/types";
import { TRouteWithRedirect, useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

const BTSG60Page = (): React.ReactElement => {
  const { context } =
    useRouteContext<TRouteWithRedirect<BTSG60Context, string>>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {({ kind, data }) => {
        if (kind === "keyword") return <BTSG60PageContent data={data} />;

        // Default error page.
        return <CustomError statusCode={HttpStatusCode.NotFound} />;
      }}
    </Await>
  );
};

export default BTSG60Page;
